import { z } from "zod";

/**
 * The hosted page's session header (ADR-5.3): requests carry the token in it, and a response
 * that opened a session returns the new token in it.
 */
export const SESSION_HEADER = "x-shopper-session";

/**
 * The retailer's own id for a shopper, however it reaches us: a launch token's `sub`, the API's
 * `shopperId`, a session link. One rule, so a shopper opened one way can be addressed the others.
 * `wa:` is reserved for WhatsApp BSUIDs (ADR-2.6): no other caller may claim one.
 */
export const shopperIdSchema = z
	.string()
	.min(1)
	.max(128)
	.refine((value) => !value.startsWith("wa:"), {
		message: "Shopper ids starting with wa: are reserved",
	});
